import './applianceOptions.scss';

import { graphql, useStaticQuery } from 'gatsby';

import ApplianceOptionsPrice from './ApplianceOptionsPrice';
import GatsbyImageWrapper from '../GatsbyImageWrapper';
import { Icon } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Pagination from '../Pagination';
import React from 'react';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function ApplianceOptions(props: {
    code?: string;
    options: any;
    page: any;
    setPage: any;
    options_requise: any;
}) {
    const { options, page, setPage, options_requise } = props;
    const { currentLocale } = usePageLocalization();
    const currentDevice = useMobileDetect();
    const downloadIcon =
        'M21.516,10.507h-4V4.5H11.5v6.007h-4l7.008,7.008ZM7.5,19.517v2H21.516v-2Z';
    const isMobile = currentDevice.isMobile();
    const optionsPerPage = 6;
    const { t } = useTranslation('templatePages');
    const allProducts = useStaticQuery(
        graphql`
            query {
                allProductsJson {
                    nodes {
                        code
                        images
                        fields {
                            ...productsFieldsImagesFragment
                        }
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        documents {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        `
    );
    const products = allProducts.allProductsJson.nodes;
    let options_requise_cp: any[] = [];

    if (options_requise) {
        options_requise_cp = options_requise.map((e: any) => {
            return {
                code: e?.en_CA,
            };
        });
    }
    const allOptions = [...options_requise_cp, ...options];

    function isRequiredOption(code: string): boolean {
        return options_requise_cp.find((e: any) => e.code === code);
    }

    const getCurrentOptionsPage = (): any[] => {
        if (isMobile) {
            return allOptions;
        }

        return allOptions?.slice(
            optionsPerPage * (page - 1),
            optionsPerPage * page
        );
    };

    return (
        <>
            <div className='appliance-options'>
                {getCurrentOptionsPage().map((option: any, index: number) => {
                    const product = products.find(
                        (product: any) => product.code === option.code
                    );

                    if (product) {
                        return (
                            <div className='appliance-option' key={index}>
                                <div className='option-infos'>
                                    <span className='name'>
                                        {product?.title?.[currentLocale]}
                                    </span>
                                    <div className='code-container'>
                                        <span className='code'>
                                            {product?.code}
                                        </span>
                                        {product?.documents && (
                                            <span className='download-icon'>
                                                <Icon
                                                    className='icon'
                                                    d={downloadIcon}
                                                    size='14'
                                                    viewbox='0 0 14.016 17.019'
                                                    transform='translate(-7.5 -4.5)'
                                                    color='#B2B2B2'
                                                />

                                                <a
                                                    rel='noreferrer'
                                                    target='_blank'
                                                    href={
                                                        '/file/' +
                                                        product?.documents?.[0][
                                                            currentLocale
                                                        ]
                                                    }
                                                    className='document'
                                                    download
                                                >
                                                    {t(
                                                        'appliance-page.download-manual'
                                                    )}
                                                </a>
                                            </span>
                                        )}
                                    </div>

                                    <ApplianceOptionsPrice
                                        code={product?.code}
                                    />
                                </div>
                                <div className='image'>
                                    <GatsbyImageWrapper
                                        fields={product.fields}
                                      
                                    />
                                    {isRequiredOption(product?.code) && (
                                        <span className='required-opt-tag'>
                                            {t(
                                                'appliance-page.required-option'
                                            )}
                                        </span>
                                    )}
                                </div>
                            </div>
                        );
                    }
                })}
            </div>

            {!isMobile && allOptions.length / optionsPerPage > 1 && (
                <Pagination
                    currentPage={page}
                    onPageChange={(newPage: number) => setPage(newPage)}
                    pageNumber={Math.ceil(allOptions.length / optionsPerPage)}
                />
            )}
        </>
    );
}
